/* Shared early-head/runtime policy. Local state only; no network requests. */
(function (root) {
    'use strict';
    if (root.pixelmateGTMConsent) return;
    function resolve(config, decision) {
        // Bots ("Cookie Banner für Bots deaktivieren") get full consent: every
        // service, gate and signal granted, independent of any stored decision.
        if (config.bot === true) decision = { categories: { analytics: true, marketing: true, external: true }, services: {} };
        var bot = config.bot === true;
        var valid = !!(decision && decision.categories && !Array.isArray(decision.categories)
            && ['analytics', 'marketing', 'external'].every(function (key) {
                return typeof decision.categories[key] === 'boolean';
            }));
        var categories = valid ? decision.categories : {};
        var explicit = valid && decision.services || {};
        var registry = config.services || {};
        var services = {}, gates = {}, signals = {};
        // "Folgt den Diensten": GTM hat keinen eigenen Schalter, also kein Veto.
        var veto = config.followsServices !== true && explicit.google_tag_manager === false;
        Object.keys(registry).forEach(function (key) {
            var category = registry[key];
            var allowed = valid && (typeof explicit[key] === 'boolean'
                ? explicit[key] : category !== 'necessary' && categories[category] === true);
            services[key] = !veto && allowed;
            // Advanced pre-consent traffic is opt-in per Google service, never for Meta.
            gates[key] = services[key] || (!valid && !veto && config.mode === 'advanced'
                && (key === 'google_analytics' || key === 'google_ads')
                && (config.advancedServices || []).indexOf(key) !== -1);
        });
        var mapping = Object.assign({
            analytics_storage: 'google_analytics', ad_storage: 'google_ads',
            ad_user_data: 'google_ads', ad_personalization: 'google_ads'
        }, config.parameterServices || {});
        // Ohne registrierte GTM-Dienste folgen die Google-Signale wie bis 5.0.18
        // den Kategorien, sonst blieben sie bei Bestandsinstallationen trotz
        // Einwilligung dauerhaft denied.
        var legacy = Object.keys(registry).length === 0 && valid && !veto;
        var legacyCategory = { analytics_storage: 'analytics', ad_storage: 'marketing',
            ad_user_data: 'marketing', ad_personalization: 'marketing' };
        (config.consentParameters || []).forEach(function (key) {
            var granted = legacy && legacyCategory[key]
                ? categories[legacyCategory[key]] === true
                : services[mapping[key]] === true;
            signals[key] = bot || granted ? 'granted' : 'denied';
        });
        Object.keys(services).forEach(function (key) {
            signals['pixelmate_' + key] = gates[key] ? 'granted' : 'denied';
        });
        var container = bot || !veto && (config.mode === 'advanced'
            || Object.keys(services).some(function (key) { return services[key]; })
            || (Object.keys(registry).length === 0 && valid
                && (explicit.google_tag_manager === true
                    || (config.category !== 'necessary' && categories[config.category] === true))));
        return { categories: categories, services: services, gates: gates,
            signals: signals, container: container, decision: valid };
    }
    var listeners = [];
    var api = {
        resolve: resolve,
        // Storage signals only (no pixelmate_* gates), without touching state,
        // listeners or the container: used right before a CSP reload.
        storageSignals: function (decision) {
            var signals = resolve(root.pixelmateGTMConfig || {}, decision).signals, out = {};
            Object.keys(signals).forEach(function (key) {
                if (key.indexOf('pixelmate_') !== 0) out[key] = signals[key];
            });
            return out;
        },
        state: null,
        loadedContainer: false,
        needsReload: false,
        // Used by the sandboxed GTM template. Immediate callback precedes tag evaluation.
        subscribe: function (callback) {
            listeners.push(callback);
            if (api.state) callback(api.state.signals);
        },
        update: function (decision, options) {
            var config = root.pixelmateGTMConfig || {};
            var state = resolve(config, decision);
            if (api.loadedContainer && api.state && (!state.container
                || Object.keys(api.state.gates).some(function (key) {
                    return api.state.gates[key] && !state.gates[key];
                }))) api.needsReload = true;
            api.state = state;
            if (config.consentMode && typeof root.gtag === 'function') {
                root.gtag('consent', 'update', state.signals);
            }
            listeners.forEach(function (callback) { callback(state.signals); });
            if (options && options.silent) return state;
            root.dataLayer = root.dataLayer || [];
            root.dataLayer.push({ event: 'pixelmate_consent_update', pixelmate_consent: state });
            if (state.container) api.activate();
            return state;
        },
        activate: function () {
            // Inert even in Advanced mode until defaults + saved decision have been applied.
            if (!api.state || !api.state.container) return;
            root.document.querySelectorAll('script[type="text/plain"][data-consent-service="google_tag_manager"]').forEach(function (old) {
                api.loadedContainer = true;
                var script = root.document.createElement('script');
                script.type = old.getAttribute('data-pixelmate-script-type') || 'text/javascript';
                if (old.nonce) script.nonce = old.nonce;
                if (old.dataset.src) { script.src = old.dataset.src; script.async = false; }
                script.textContent = old.textContent;
                script.setAttribute('data-pixelmate-managed', 'true');
                old.replaceWith(script);
            });
            // No noscript fallback: JavaScript-disabled browsers cannot prove consent.
        }
    };
    root.pixelmateGTMConsent = api;
})(window);
